<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[sessions$]"></ef-loading-container>
<div>

</div>
<form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-datepicker
                formControlName="startDate"
                [(ngModel)]="startDate"
                appendTo="body"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-20, 'year').format('YYYY') +
                    ':' +
                    moment().add(1, 'year').format('YYYY')
                "
            ></p-datepicker>
            <label for="float-dd">Start Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-datepicker
                formControlName="endDate"
                [(ngModel)]="endDate"
                appendTo="body"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-20, 'year').format('YYYY') +
                    ':' +
                    moment().add(1, 'year').format('YYYY')
                "
                [minDate]="startDate"
                [maxDate]="this.maxDate"
            ></p-datepicker>
            <label for="float-dd">End Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-multiSelect
                id="ddContract"
                #contract
                formControlName="ContractListID"
                [options]="contractsSelectItems$ | async"
                [(ngModel)]="selectedContracts"
                appendTo="body"
                maxSelectedLabels="1"
            ></p-multiSelect>
            <label for="float-dd">Contract</label>
        </p-floatLabel>
        <!-- <span>
            <p-checkbox
                #invoicesOnly
                binary="true"
                formControlName="invoicesOnly"
            ></p-checkbox>
            <label style="margin-left: -0.5em;"> show only rows with invoice numbers assigned </label>
        </p-floatLabel> -->
    </p-toolbar>
</form>
<p-accordion [multiple]="true">
    <p-accordionTab #tabSessions [selected]="true">
        <ng-template #header>
            <span *ngIf="startDate && endDate">
                Activity for {{ startDate | date: 'MM/dd/yyyy' }} -
                {{ endDate | date: 'MM/dd/yyyy' }}
            </span>
        </ng-template>
        <div style="height: 70vh;">
            <ef-invoice-session-number
                [userInfo]="userInfo$ | async"
                [process]="process$ | async"
                [items]="sessions$ | async"
                (SaveItem)="onSaveSession($event)"
                (DeleteInvoiceSessions)="onDeleteInvoiceSessions($event)"
            ></ef-invoice-session-number>
        </div>
    </p-accordionTab>
</p-accordion>
